<template>
  <div class="v-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ValSetBox",
  // props: {
  //   name: {
  //     type: String,
  //     default: '--'
  //   },
  // },
}
</script>

<style lang="scss" scoped>
.v-box {
  background-color: #edfbff;
  width: calc(100% - 32px);
  margin: 8px;
  border: 1px solid #409EFF;
  border-radius: 8px;
  padding: 8px;
  position: relative;
}
</style>